export default __webpack_public_path__ + "static/media/googleplay_fr_badge_web.dea968ca.png";